export default {
  OVERRIDE_DESIGN_PANEL: 'OVERRIDE_DESIGN_PANEL',
  CUSTOMIZE_DESIGN_ONLY: 'CUSTOMIZE_DESIGN_ONLY',
  SHOW_COMPLETE_PANEL: 'SHOW_COMPLETE_PANEL',
};
